import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { inject } from '@app/providers/QAU.ContextProvider';
import { updateCustomizeAction, setSnapToEdgeEnabled } from '@app/actions/customizeActions';
import LocalizedText from '@LocalizedText';
import { connect } from 'react-redux';

import './SnapToEdge.scss';

const SnapToEdge = ({ snapToEdgeEnabled, setSnapToEdgeEnabled, updateCustomizeAction, flow }) => {
  const updateSnapToEdge = useCallback(
    ({ target: { checked } }) => {
      const {
        editor: { transformTool },
      } = flow;

      setSnapToEdgeEnabled(checked);
      updateCustomizeAction('toolSnapToEdge', { value: checked });
      transformTool.snapToEdgeEnabled = checked;
    },
    [flow, updateCustomizeAction],
  );

  return (
    <div id="snap-to-edge-tool">
      <label htmlFor="snap-checkbox">
        <input id="snap-checkbox" type="checkbox" onChange={updateSnapToEdge} defaultChecked={snapToEdgeEnabled} />
        <LocalizedText id="qau-tool-snap-to-edge" tagName="span" />
      </label>
    </div>
  );
};

const mapStateToProps = ({
  customize: {
    customizeData: {
      snapToEdgeEnabled,
    },
  },
}) => ({ snapToEdgeEnabled });

const mapDispatchToProps = {
  setSnapToEdgeEnabled,
  updateCustomizeAction,
};

SnapToEdge.propTypes = {
  snapToEdgeEnabled: PropTypes.bool.isRequired,
  setSnapToEdgeEnabled: PropTypes.func.isRequired,
  updateCustomizeAction: PropTypes.func.isRequired,
  flow: PropTypes.object.isRequired,
};

export default inject('flow')(connect(mapStateToProps, mapDispatchToProps)(SnapToEdge));
